import { useCurrentCompany } from './use-current-company';

/**
 * Hook to determine if user-facing Bizy should be enabled for the current user.
 */
export function useIsBizyEnabled(): boolean {
	const company = useCurrentCompany();

	return company?.bizy_enabled || false;
}
